
import { PageViewTracker, PublicPageViewTracker } from "../views/pageview-tracker"
import { PublicSectionViewTracker, SectionViewTracker } from "../views/section-view-tracker"
import { publicSiteVisitTracker, SiteVisitTracker } from "../views/sitevisit-tracker";

// PAYLOAD PARA EL SITEVISIT
export interface Payload {
    device: string,
    device_type_id: number,
    ip: string,
    location: string,
    country: string,
    user_agent: string,
    source_id: number
};

export type BasePayload = { siteVisitUuid: string };

// BASE DEL PAYLOAD PARA TODOS LOS VIEWS
export interface OpenViewBasePayload extends Payload {
    site_visit_id: string | null
}

// BASE DEL PAYLOAD PARA PAGE VIEW
export interface PageViewPayload extends OpenViewBasePayload {
    name: string,
    url: string
}

// BASE DEL PAYLOAD PARA SECTION VIEW
export interface OpenSectionViewPayload extends OpenViewBasePayload {
    section_id: string,
}

// BASE DEL PAYLOAD PARA CATEGORY VIEW
export interface OpenCategoryViewPayload extends OpenViewBasePayload {
    category_id: number,
}

// BASE DEL PAYLOAD PARA SUBCATEROGY VIEW
export interface OpenSubCategoryViewPayload extends OpenViewBasePayload {
    sub_category_id: number,
}

// BASE DEL PAYLOAD PARA TOOLKIT VIEW
export interface OpenToolkitViewPayload extends OpenViewBasePayload {
    toolkit_id: number
}


export interface OpenBaseContentViewPayload extends OpenViewBasePayload {
    client_id: number,
    content_id: number
}

// BASE DEL PAYLOAD PARA CONTENT VIEW SI VIENE DE TOOLKIT SECTION VIEW
export interface OpenToolKitContentViewPayload extends OpenBaseContentViewPayload {
    toolkit_section_id: number
}

// BASE DEL PAYLOAD PARA CONTENT VIEW SI 'ESTA' EN UNA SERIE. DISTINTO A SI 'ES' UNA SERIE
export interface OpenSerieContentViewPayload extends OpenBaseContentViewPayload {
    serie_id: number
}

// BASE DEL PAYLOAD PARA CONTENT VIEW SI ESTA EN UN SUBPLAN
export interface OpenSubplanContentViewPayload extends OpenBaseContentViewPayload {
    language_id: number,
    subplan_module_content_id: number
}

// BASE DEL PAYLOAD PARA CONTENT VIEW SI ESTA EN MODULO DE RUTA
export interface OpenRouteContentViewPayload extends OpenBaseContentViewPayload {
    language_id: number,
    route_module_content_id: number
}

// BASE DEL PAYLOAD PARA CONTENT VIEW POR DEFAULT
export interface OpenDefaultContentViewPayload extends OpenBaseContentViewPayload {
    language_id: number,
}

// BASE DEL PAYLOAD PARA CONTENT VIEW SI 'ES' UNA SERIE. DISTINTO A SI 'ESTA' EN UNA SERIE
export interface OpenSerieViewPayload extends OpenBaseContentViewPayload {
    serie_last_content_id: number,
}

export interface ContentSource {
    name: string,
    url: string,
    id: number
}

// BASE DEL PAYLOAD PARA EXTRAS DE CONTENT VIEW
export interface ContentViewExtras {
    languageId: number,
    contentTypeId: number
}

// BASE DEL PAYLOAD PARA PINGS DE CONTENT VIEW SI SON ARTICULOS
export interface PingContentViewArticlePayload {
    last_played_at: number
}

// BASE DEL PAYLOAD PARA PINGS DE CONTENT VIEW SI SON AUDIO O VIDEOS
export interface PingContentViewMediaPayload extends PingContentViewArticlePayload {
    effective_duration: number,
    last_played_variant_id?: number
}

// BASE DEL PAYLOAD PARA PING CONTENT VIEW SI 'ES' UNA SERIE
export interface PingSerieViewPayload {
    serie_last_content_id: number
}

// BASE DEL PAYLOAD PARA START DE CONTENT VIEW
export interface StartContentViewPayload {
    last_played_variant_id: number
}

// BASE DEL PAYLOAD PARA FINISH DE CONTENT VIEW SI 'ES' UNA SERIE
export interface FinishSerieViewPayload {
    serie_last_content_id: number
}

export type PingContentViewPayload =
    | PingContentViewArticlePayload
    | PingContentViewMediaPayload;

export type OpenContentViewPayload =
    | OpenToolKitContentViewPayload
    | OpenSerieContentViewPayload
    | OpenSubplanContentViewPayload
    | OpenRouteContentViewPayload
    | OpenDefaultContentViewPayload;

export enum ViewTrackerType {
    Site = 'sitevisit',
    Page = 'page',
    Section = 'section'
}

export type TrackerMap = {
    [ViewTrackerType.Site]: SiteVisitTracker | null;
    [ViewTrackerType.Page]: PageViewTracker;
    [ViewTrackerType.Section]: SectionViewTracker;
};

export type PublicTrackerMap = {
    [ViewTrackerType.Site]: publicSiteVisitTracker | null;
    [ViewTrackerType.Page]: PublicPageViewTracker;
    [ViewTrackerType.Section]: PublicSectionViewTracker;
};

export type OpenViewPayloadMap = {
    [ViewTrackerType.Page]: PageViewPayload;
    [ViewTrackerType.Section]: OpenSectionViewPayload;
};

export type CloseViewPayloadMap = {
    [ViewTrackerType.Page]: undefined;
    [ViewTrackerType.Section]: undefined;
};

export type StartViewPayloadMap = {
    [ViewTrackerType.Page]: undefined;
    [ViewTrackerType.Section]: undefined;
};

export type FinishViewPayloadMap = {
    [ViewTrackerType.Page]: undefined;
    [ViewTrackerType.Section]: undefined;
};

export type PingViewPayloadMap = {
    [ViewTrackerType.Page]: undefined;
    [ViewTrackerType.Section]: undefined;
};



